function openGroup(groupId) {
  window.open(`/groups/${groupId}`);
}

export default openGroup;